import { render, staticRenderFns } from "./JotformImport.vue?vue&type=template&id=7873402e&lang=pug"
import script from "./JotformImport.vue?vue&type=script&lang=js"
export * from "./JotformImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports